import { addEmployeeTourSteps } from './addEmployee.tour';
import { downloadDesktopAppTourSteps } from './downloadDesktopApp.tour';
import { productivityDataTourSteps } from './productivityData.tour';

// Map URL ?tour= values to their step arrays
export const tourRegistry = {
  'add-employee': addEmployeeTourSteps,
  'download-desktop-app': downloadDesktopAppTourSteps,
  'productivity-data': productivityDataTourSteps,
};
